module.exports = __webpack_public_path__ + "img/orange_098.dc6063b9.png";